export class Icon {
  public Icon: string;

  public IconSet?: string;
}

